module.exports = __webpack_public_path__ + "deQOb6xYFjuKhT0iy/RDC_RED_Logo_House.svg";